// Copyright (c) 2024, WSO2 LLC. (https://www.wso2.com). All Rights Reserved.
//
// This software is the property of WSO2 LLC. and its suppliers, if any.
// Dissemination of any information or reproduction of any material contained
// herein in any form is strictly forbidden, unless permitted by WSO2 expressly.
// You may not alter or remove any copyright or other notice from copies of this content.

import {
  Box,
  CircularProgress,
  LinearProgress,
  Typography,
} from "@mui/material";

export const LoadingEffect = (props: {
  message: string | null;
  isCircularLoading?: boolean;
  isFullscreen?: boolean
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        rowGap: 1,
        height: (props.isFullscreen ? "100%" : "calc(100vh - 415px)"),
      }}
    >
      {props.isCircularLoading ? (
        <CircularProgress />
      ) : (
        <LinearProgress sx={{ width: "100px" }} />
      )}
      <Typography variant="inherit">{props.message}</Typography>
    </Box>
  );
};
